import type {
  Allergy,
  DietType,
  EatingGoal,
  OnboardingStep,
  WeekDay,
} from './types';

// Weekdays
export const WEEKDAYS: { value: WeekDay; label: string; shortLabel: string }[] =
  [
    { value: 'T2', label: 'Thứ 2', shortLabel: 'T2' },
    { value: 'T3', label: 'Thứ 3', shortLabel: 'T3' },
    { value: 'T4', label: 'Thứ 4', shortLabel: 'T4' },
    { value: 'T5', label: 'Thứ 5', shortLabel: 'T5' },
    { value: 'T6', label: 'Thứ 6', shortLabel: 'T6' },
  ];

// Eating Goals
export const EATING_GOALS: {
  value: EatingGoal;
  label: string;
  description: string;
  icon: string;
}[] = [
  {
    value: 'weight_loss',
    label: 'Giảm cân',
    description: 'Giúp bạng muốn giảm cân để lành mạnh hơn',
    icon: 'weight-loss.png',
  },
  {
    value: 'muscle_gain',
    label: 'Tăng cơ',
    description: 'Giúp bạn phát triển cơ bắp',
    icon: 'muscle.png',
  },
  {
    value: 'maintain',
    label: 'Giữ dáng',
    description: 'Duy trì cân nặng và vóc dáng hiện tại',
    icon: 'health.png',
  },
  // {
  //   value: 'balanced',
  //   label: 'Cân bằng',
  //   description: 'Thực đơn đa dạng, đủ chất cho cơ thể',
  //   icon: 'goal-balanced.webp',
  // },
  // {
  //   value: 'low_carb',
  //   label: 'Ít tinh bột',
  //   description: 'Hạn chế tinh bột, giàu protein',
  //   icon: 'goal-low-carb.webp',
  // },
  // {
  //   value: 'high_protein',
  //   label: 'Giàu đạm',
  //   description: 'Bổ sung protein cho cơ thể',
  //   icon: 'goal-protein.webp',
  // },
  // {
  //   value: 'pescatarian',
  //   label: 'Ăn chay có cá',
  //   description: 'Không ăn thịt, chỉ ăn cá và hải sản',
  //   icon: 'goal-pescatarian.webp',
  // },
];

// Diet Types
export const DIET_TYPES: {
  value: DietType;
  label: string;
  description: string;
  icon: string;
  color: string;
}[] = [
  {
    value: 'balanced',
    label: 'Cân bằng',
    description:
      'Đa dạng các nhóm thực phẩm với tỷ lệ hợp lý và nguyên liệu chất lượng, đảm bảo đủ dinh dưỡng mỗi ngày.',
    icon: 'ai-planner-diet-1.webp',
    color: '#F0C3C0',
  },
  {
    value: 'vegan',
    label: 'Thuần chay',
    description:
      'Chế độ ăn không sử dụng sản phẩm từ động vật, chỉ gồm thực phẩm có nguồn gốc thực vật.',
    icon: 'ai-planner-diet-2.webp',
    color: '#97C584',
  },
  {
    value: 'vegetarian',
    label: 'Chay có sữa/trứng',
    description:
      'Giảm tinh bột (cơm, bún, bánh), tăng đạm và chất béo tốt để hỗ trợ giảm cân.',
    icon: 'ai-planner-diet-3.webp',
    color: '#E27F44',
  },
  {
    value: 'high_protein',
    label: 'Giàu protein',
    description:
      'Tăng lượng protein, giảm tinh bột và chất béo xấu để hỗ trợ cơ bắp và sức khoẻ.',
    icon: 'ai-planner-diet-4.webp',
    color: '#F4B43D',
  },
  {
    value: 'low_carb',
    label: 'Ít carb',
    description:
      'Ăn thực vật kết hợp hải sản và sữa, không ăn thịt đỏ và gia cầm.',
    icon: 'ai-planner-diet-5.webp',
    color: '#6BD6DD',
  },
];

// Allergies
export const ALLERGIES: {
  value: Allergy;
  label: string;
  icon: string;
}[] = [
  { value: 'dairy', label: 'Sữa', icon: 'milk.svg' },
  { value: 'nuts', label: 'Hạt', icon: 'hazelnut.svg' },
  // { value: 'peanuts', label: 'Đậu phộng', icon: 'peanuts.svg' },
  { value: 'coffee', label: 'Cà phê', icon: 'coffee.svg' },
  // { value: 'caffein', label: 'Caffein', icon: 'caffein.svg' },
  { value: 'cheese', label: 'Phô mai', icon: 'cheese.svg' },
  // { value: 'gluten', label: 'Gluten', icon: 'gluten.svg' },
  { value: 'shrimp', label: 'Tôm', icon: 'shrimp.svg' },
  // {
  //   value: 'shellfish',
  //   label: 'Hải sản có vỏ',
  //   icon: 'shellfish.svg',
  // },
  { value: 'eggs', label: 'Trứng', icon: 'eggs.svg' },
  // { value: 'soy', label: 'Đậu nành', icon: 'soy.svg' },
];

// Quick date range options
export const DATE_RANGE_OPTIONS: {
  value: number;
  label: string;
  days: number;
}[] = [
  { value: 1, label: '1 tuần', days: 7 },
  { value: 2, label: '2 tuần', days: 14 },
  { value: 3, label: '3 tuần', days: 21 },
];

// Step order for navigation
export const STEP_ORDER: OnboardingStep[] = [
  'intro',
  'delivery_days',
  'personal_info',
  'eating_goals',
  'diet_type',
  'allergies',
  'processing',
  'overview',
];

// Required steps (must complete before generating)
export const REQUIRED_STEPS: OnboardingStep[] = ['delivery_days'];

// Optional steps (can skip)
export const OPTIONAL_STEPS: OnboardingStep[] = [
  'personal_info',
  'eating_goals',
  'diet_type',
  'allergies',
];

// Step progress percentages for "AI học" indicator
export const STEP_PROGRESS: Record<OnboardingStep, number> = {
  intro: 0,
  delivery_days: 20,
  personal_info: 10,
  eating_goals: 25,
  diet_type: 50,
  allergies: 75,
  processing: 99,
  overview: 100,
};

// Mapping UI values to API values
export const EATING_GOAL_API_MAP: Record<EatingGoal, string> = {
  weight_loss: 'weight loss',
  muscle_gain: 'gain muscle',
  maintain: 'maintain weight',
  balanced: 'balanced',
  low_carb: 'low carb',
  high_protein: 'high protein',
  pescatarian: 'pescatarian',
};

export const DIET_TYPE_API_MAP: Record<DietType, string> = {
  balanced: 'balanced',
  vegan: 'vegan',
  vegetarian: 'vegetarian',
  keto: 'keto',
  paleo: 'paleo',
  high_protein: 'high protein',
  low_carb: 'low carb',
};

export const ALLERGY_API_MAP: Record<Allergy, string> = {
  dairy: 'dairy',
  nuts: 'nuts',
  peanuts: 'peanuts',
  coffee: 'coffee',
  caffein: 'caffein',
  cheese: 'cheese',
  gluten: 'gluten',
  shellfish: 'shellfish',
  shrimp: 'shrimp',
  eggs: 'eggs',
  soy: 'soy',
};

// Intro screen content
export const INTRO_SCREENS = [
  {
    title: 'Trợ lý bữa trưa tự động',
    benefits: [
      {
        icon: 'check',
        title: 'Chọn món theo sở thích và đặt bữa trưa dùng lịch đã thiết lập',
      },
      {
        icon: 'clock',
        title: 'Giao đúng giờ, không lo phí ship',
        description:
          'Vì khi lên lịch xong, trợ lý AI sẽ tự động gửi tìm kiếm giúp đến và đặt bữa trưa trước đó.',
      },
      {
        icon: 'control',
        title: 'Bạn luôn toàn quyền kiểm soát',
        description: 'Có thể chỉnh hoặc tạm dừng bất cứ lúc nào.',
      },
    ],
    cta: 'Bắt đầu ngay',
  },
  {
    title: 'Chỉ với 2 bước',
    steps: [
      {
        number: 1,
        title: 'Xem trước kế hoạch',
        description: 'Xem lịch quán ăn, khẩu phần ăn & chi phí dự kiến',
      },
      {
        number: 2,
        title: 'Khởi động kế hoạch theo ngày',
        description:
          'Nhập thông tin giao hàng, ngân sách. AI tự động tìm món và đặt món theo kế hoạch',
      },
    ],
    footer:
      'Bạn hay đói đến trưa mới nghĩ hôm nay ăn gì? Hãy thiết lập hồ sơ để chúng tôi gợi ý!',
    cta: 'Bắt đầu ngay',
  },
];

// Banner dismiss storage key
export const BANNER_DISMISS_KEY = 'ahafood.ai-planner.banner-dismissed';

// Store name for persistence
export const AI_PLANNER_STORE_NAME = 'ahafood.ai-planner';

// Default time slot
export const DEFAULT_TIME_SLOT = 'lunch';

// API endpoint env var name
export const MEAL_PLANNER_API_ENV = 'NEXT_PUBLIC_MEAL_PLANNER_API';
